import React, { useState, useEffect, useCallback, Fragment } from "react";

import { OptionList } from '../uiParts/options/OptionList';

const Options = (props) => {
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [filters, setFilters] = useState([]);
  const { init_options, init_filters } = props;
  // 初期設定データセット
  useEffect(() => {
    setOptions([...init_options]);
    setFilters([...init_filters]);
    setLoading(false);
  }, []);

  const addOption = useCallback((new_item) => {
    setOptions([...options, new_item]);
  }, [options]);
  const removeOption = useCallback((remove_item) => {
    setOptions(options.filter(option => {
      return option.id !== remove_item;
    }));
  }, [options]);

  return (
    <>
      {loading ?
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        :
        <Fragment>
          <label className="fw-bold">検査オプション</label>
          <div className="options">
            <OptionList
              items={options}
              filters={filters}
              addOption={addOption}
              removeOption={removeOption} />
          </div>
        </Fragment>
      }
    </>
  );
};

export default Options;
